var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 7.49997V12.5C18.3334 14.5833 17.9168 16.0416 16.9834 16.9833L11.6667 11.6666L18.1084 5.22498C18.2584 5.88331 18.3334 6.63331 18.3334 7.49997Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1084 5.22502L5.22507 18.1084C2.71674 17.5334 1.66675 15.8 1.66675 12.5V7.50002C1.66675 3.33335 3.33341 1.66669 7.50008 1.66669H12.5001C15.8001 1.66669 17.5334 2.71669 18.1084 5.22502Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9834 16.9834C16.0418 17.9167 14.5834 18.3334 12.5001 18.3334H7.50011C6.63344 18.3334 5.88343 18.2584 5.2251 18.1084L11.6668 11.6667L16.9834 16.9834Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19997 6.64998C5.76664 4.20831 9.43332 4.20831 9.99998 6.64998C10.325 8.08331 9.42497 9.29998 8.6333 10.05C8.0583 10.6 7.14999 10.6 6.56665 10.05C5.77499 9.29998 4.86664 8.08331 5.19997 6.64998Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57884 7.25004H7.58632",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.60c8909aaffe59f658e1ce9b9d99f052.svg";
export { ForwardRef as ReactComponent };